export default "__VITE_ASSET__1KRPjwhG__"